// Utility per gestire gli articoli del blog

// Importa tutti i file markdown dalla cartella blog
const blogPosts = import.meta.glob('/content/blog/*.md', { 
  eager: true,
  as: 'raw'
});

// Funzione per parsare il frontmatter
function parseFrontmatter(content) {
  const frontmatterRegex = /^---\s*\n([\s\S]*?)\n---\s*\n([\s\S]*)$/;
  const match = content.match(frontmatterRegex);
  
  if (!match) {
    return { frontmatter: {}, content };
  }
  
  const frontmatterStr = match[1];
  const bodyContent = match[2];
  
  const frontmatter = {};
  frontmatterStr.split('\n').forEach(line => {
    const [key, ...valueParts] = line.split(':');
    if (key && valueParts.length) {
      let value = valueParts.join(':').trim();
      // Rimuovi le virgolette
      value = value.replace(/^["'](.*)["']$/, '$1');
      frontmatter[key.trim()] = value;
    }
  });
  
  return { frontmatter, content: bodyContent };
}

// Ottieni tutti gli articoli
export function getAllPosts() {
  const posts = [];
  
  for (const path in blogPosts) {
    const content = blogPosts[path];
    const { frontmatter, content: body } = parseFrontmatter(content);
    
    // Estrai lo slug dal path
    const slug = path.replace('/content/blog/', '').replace('.md', '');
    
    const tags = frontmatter.tags
      ? frontmatter.tags.split(',').map(t => t.trim()).filter(Boolean)
      : [];

    posts.push({
      slug,
      title: frontmatter.title || 'Senza titolo',
      date: frontmatter.date || '',
      excerpt: frontmatter.excerpt || '',
      image: frontmatter.image || '',
      tags,
      content: body
    });
  }

  // Ordina per data (più recenti prima)
  return posts.sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateB - dateA;
  });
}

// Ottieni un singolo post per slug
export function getPostBySlug(slug) {
  const path = `/content/blog/${slug}.md`;
  
  if (!blogPosts[path]) {
    return null;
  }
  
  const content = blogPosts[path];
  const { frontmatter, content: body } = parseFrontmatter(content);
  
  return {
    slug,
    title: frontmatter.title || 'Senza titolo',
    date: frontmatter.date || '',
    excerpt: frontmatter.excerpt || '',
    image: frontmatter.image || '',
    content: body
  };
}

// Formatta la data in italiano
export function formatDate(dateString) {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  return date.toLocaleDateString('it-IT', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}
